import React from 'react';

import {message} from 'antd';
import {observable} from "mobx";
import http from 'libs/http';

class Store {
  @observable invoices = [];
  @observable invoice = {};
  @observable index = 0;
  @observable isFetching = false;


  //获取地址列表
  fetchRecodes = () => {
    this.isFetching = true;
    return http.get('/api/front/customer/invoice/')
      .then(data => {
        this.invoices = data
      })
      .finally(() => this.isFetching = false)
  }

  update = (data) => {
    return http.post('/api/front/customer/invoice/', data)
      .then(res => {
        this.invoice = data

        if (data.id) {
          this.invoices[this.index] = data
        } else {
          this.invoices.push(data)
          //TODO 新增的需要返回id
        }
        message.success('地址保存成功！')
      })
      .finally(() => this.isFetching = false)
  }


  setDefault = () => {
    let data = Object.assign({}, this.invoices[this.index], {is_default: true})

    return http.patch('/api/front/customer/invoice/', data)
      .then(res => {
        this.invoices.map(v => v.is_default = false)
        this.invoices[this.index]['is_default'] = true
        message.success('默认地址修改成功！')
      })
      .finally(() => this.isFetching = false)
  }

  del = (index) => {
    this.isFetching = true;
    http.delete('/api/front/customer/invoice/?id=' + this.invoices[index]['id'])
      .then(data => {
        this.invoices.splice(index, 1)
      })
      .finally(() => this.isFetching = false)
  }


}

export default new Store()


// 发票

//address: "河南省新乡市延津县僧固乡大佛村509号"
// bank_name: "交通"
// bank_number: "46498416516546846541"
// create_time: "2020-11-03 19:42:42"
// customer_id: 8
// id: 263
// is_default: false
// organization_id: null
// phone: "18703644856"
// tax_sn: "123123123123123123"
// title: "申长伟"
